export const environment = {
  production: false,

  apiUrl: 'https://kundportal-test.kulladal.me/api',
}
